import * as FilePond from "filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

FilePond.registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

const fundImageInput = document.getElementById("FundImageInput");
const fileInput = document.getElementById("FundImagePond");

if (fileInput) {

    const maxUploads = parseInt(fileInput.dataset.maxUploads, 5) || 1;

    let uploadedIds = [];

    function updateHiddenInput() {
        fundImageInput.value = uploadedIds.length > 0 ? JSON.stringify(uploadedIds) : "";
    }

    const labelIdleText = maxUploads === 1
        ? 'Drag & Drop your image or <span class="filepond--label-action">Browse</span>'
        : 'Drag & Drop your images or <span class="filepond--label-action">Browse</span>';

    const pond = FilePond.create(fileInput, {
        allowMultiple: maxUploads > 1,
        acceptedFileTypes: ["image/png", "image/jpeg"],
        maxFileSize: "5MB",
        maxFiles: maxUploads,
        labelIdle: labelIdleText,
        labelMaxFileSizeExceeded: "File is too large. Maximum size is 5MB", 
        labelMaxFileSize: "Maximum file size is 5MB",
        labelMaxFileExceeded: `You can only upload up to ${maxUploads} files.`,
        maxParallelUploads: 1,
        server: {
            process: {
                url: "/umbraco/api/tributemedia/uploadimage",
                method: "POST",
                onload: (response) => {
                    try {
                        const json = JSON.parse(response);
                        const fileArray = Array.isArray(json) ? json : [json];

                        fileArray.forEach(fileData => {
                            if (fileData && fileData.id) {
                                uploadedIds.push(fileData.id);
                            }
                        });

                        uploadedIds = [...new Set(uploadedIds)];
                        updateHiddenInput();

                        console.log("Uploaded IDs:", uploadedIds);

                        return fileArray[0].id;
                    } catch (err) {
                        console.error("Invalid JSON response:", response);
                        return Promise.reject("Invalid server response");
                    }
                },
                onerror: (err) => {
                    console.error("Upload error:", err);
                    return "Upload failed";
                }
            },
            revert: (uniqueFileId, load, error) => {
                uploadedIds = uploadedIds.filter(id => id !== uniqueFileId);
                updateHiddenInput();
                load();
            }
        }
    });

    pond.on("removefile", (error, file) => {
        if (file && file.serverId) {
            uploadedIds = uploadedIds.filter(id => id !== file.serverId);
            updateHiddenInput();
        }
    });

    pond.on("processfileabort", (file) => {
        if (file && file.serverId) {
            uploadedIds = uploadedIds.filter(id => id !== file.serverId);
            updateHiddenInput();
        }
    });

    pond.on("processfileundo", (file) => {
        if (file && file.serverId) {
            uploadedIds = uploadedIds.filter(id => id !== file.serverId);
            updateHiddenInput();
        }
    });
}